import { render, staticRenderFns } from "./FormApprovals.vue?vue&type=template&id=79bc38cc&scoped=true"
import script from "./FormApprovals.vue?vue&type=script&lang=js"
export * from "./FormApprovals.vue?vue&type=script&lang=js"
import style0 from "./FormApprovals.vue?vue&type=style&index=0&id=79bc38cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc38cc",
  null
  
)

export default component.exports